<template>
  <div v-clickOutside="close" class="border" :class="isDarkMode ? 'border-hover shadow-hover' : 'border-grey-400 shadow-grey-400'">
    <div class="relative selector" @click="toggle()">
      <div class="px-12 py-8 flex justify-between items-center cursor-default" :class="[selecteClass, {'cursor-pointer': !disabled}]">
        <span class="truncate">{{ modelValue.name }}</span>
        <i v-if="!disabled" class="icon-keyboard-arrow-down" :class="{ 'expanded': visible }" />
      </div>

      <div class="absolute top-40 left-0 z-10 bg-primary shadow rounded-4 max-h-300 overflow-y-auto" :class="[{ hidden : !visible, visible }, width]">
        <p
          v-for="(item, index) in options"
          :key="item.id"
          class="border-t p-12 cursor-pointer hover:bg-selection leading-normal"
          :class="[
            isDarkMode ? 'border-hover' : 'border-grey-500',
            { 'font-semibold' : item.name === modelValue.name },
            { 'border-none': index === 0 },
            itemClass
          ]"
          @click="select(item)"
        >
          <!-- O P T I O N  N A M E -->
          <slot name="option" :item="item">
            <span>{{ item.name }}</span>
          </slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { defineComponent, ref, computed } from 'vue'

export default defineComponent({
  props: {
    modelValue: { type: Object },
    options: { type: Array },
    itemClass: { type: String },
    selecteClass: { type: String },
    width: {
      type: String,
      default: 'w-full'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  emits: ['update:modelValue'],

  setup (props, { emit }) {
    const store = useStore()
    const visible = ref(false)

    const isDarkMode = computed(() => store.getters.isDarkMode)
    const isFreePlan = computed(() => store.getters.isFreePlan)
    const user = computed(() => store.state.profile.user)

    const toggle = () => {
      if (!props.disabled) visible.value = !visible.value
    }

    const close = () => {
      visible.value = false
    }

    const select = (option) => {
      emit('update:modelValue', option)
    }

    function upgradeToPro () {
      if (user.value) {
        window.open(`https://helloivy.co/upgrade?userId=${user.value.id}`, '_blank')
      }
    }

    return { visible, isDarkMode, isFreePlan, toggle, select, upgradeToPro, close }
  }
})
</script>

<style lang="scss" scoped>
.expanded {
  transform: rotateZ(180deg) translateY(2px);
}
</style>
